import React from 'react'
import { SeriesCreateWizard } from '../components/series/series-create-wizard'
import { track } from '../lib/analytics/posthog'

const SeriesNewPage: React.FC = () => {
  React.useEffect(() => {
    track('series_pageview', { page: 'new' })
  }, [])

  return (
    <div className="mx-auto max-w-2xl py-4">
      <SeriesCreateWizard />
    </div>
  )
}

export default SeriesNewPage
